import React, { useState, useEffect, useCallback, useContext } from "react";
import debounce from "lodash/debounce";
import { toast } from "react-toastify";
import AppContext from "../../context/AppContext";
import { fetchTaskForm, saveTask, fetchFieldsValue } from "../../service/Task";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import translations from "../../components/common/Translations";
import FieldAgentModal from "./FieldAgentModal";
import BulkUploadModal from "./BulkUploadModal";
import CommonButton from "../../components/common/CommonButton";

const CreateTask = () => {
  const [accountNo, setAccountNo] = useState("");
  const [taskData, setTaskData] = useState({});
  const [remark, setRemark] = useState("");
  const [assignOpen, setAssignOpen] = useState(false);
  const [bulkUploadOpen, setBulkUploadOpen] = useState(false);
  const [allowUpdateIfExists, setAllowUpdateIfExists] = useState(false);
  const [selectedfieldAgent, setselectedfieldAgent] = useState([]);
  const [inputFields, setInputFields] = useState({
    mandatory: [],
    nonMandatory: [],
  });
  const [isCreateLoading, setIsCreateLoading] = useState(false);
  const [isCreateAssignLoading, setIsCreateAssignLoading] = useState(false);
  const [inputValues, setInputValues] = useState({});
  const [errors, setErrors] = useState({});
  const context = useContext(AppContext);
  const { projectId, theme, langMode, selectedOrgId , setSelectedOption, setWorkflowId, activityId} = context;
  const navigate = useNavigate();

  const handleGoBack = () => {
    const navigationPath =
      Cookies.get("viewmode") === "map" ? "/maptask" : "/task-manage";
    navigate(navigationPath);
    Cookies.remove("viewmode");
  };

  const handleActivityChange = async () => {
    try {
      const responseData = await fetchTaskForm(activityId);
      const responseValue = responseData.body.value;

      if (responseValue) {
        const { mandatoryFields, notMandatoryFields } = responseValue;
        setInputFields({
          mandatory: mandatoryFields || [],
          nonMandatory: notMandatoryFields || [],
        });

        const accountField = (mandatoryFields || []).find(
          (field) => field.fieldName === "Account No."
        );
        if (accountField) {
          setAccountNo(taskData[accountField.fieldName] || "");
        }
      } else {
        console.error("API response data is invalid:", responseValue);
      }

      if (responseData.header.code === 607) {
        toast.error("No data available");
        setInputFields({ mandatory: [], nonMandatory: [] });
      }
    } catch (error) {
      console.error("Error in handleActivityChange:", error);
    }
  };

  useEffect(() => {
    handleActivityChange();
  }, [activityId]);

  const handleInputChange = (fieldName, value) => {
    setTaskData((prevTaskData) => ({
      ...prevTaskData,
      [fieldName]: value,
    }));

    if (fieldName === "Account No.") {
      setAccountNo(value);
    }
  };

  const handleAddAccount  = (fieldName, value) => {
    if (value.length > 0) {
      debouncedAccountFetch( value); // Use debounced function
    }
  }

  const debouncedAccountFetch = useCallback(
    debounce((accountNo) => {
        (async () => {
          const deptId = localStorage.getItem("departmentId")?.replace(/"/g, "");
          console.log("Fetching data for account:", accountNo);
          console.log("Fetching data for Department id:", deptId);

          try {
            const responseData = await fetchFieldsValue(activityId, accountNo, selectedOrgId, projectId);
            const responseValue = responseData.body.value;
            if (responseValue) {
              setInputValues((prevValues) => ({
                ...prevValues,
                [accountNo]: responseValue,
              }));

          // Loop through the responseValue to set all fields dynamically
          const updatedTaskData = Object.keys(responseValue).reduce(
                  (acc, key) => {
                    acc[key] = responseValue[key] || "";
                    return acc;
                  },
                  {}
              );

              setTaskData((prevTaskData) => ({
                ...prevTaskData,
                ...updatedTaskData,
              }));
            }

            if (responseData.header.code === 600) {
              console.log(responseData.body.value);
            } else {
              toast.error(responseData.body.value);
            }

            if (responseData.header.code === 607) {
              toast.error("No data available");
              setInputFields([]);
            }
          } catch (error) {
            console.error("Error in accountFetch:", error);
          }
        })();
      }, 300),
      []
  );

  const handleSaveTask = async () => {
    if (
      inputFields.mandatory.length === 0 &&
      inputFields.nonMandatory.length === 0
    ) {
      toast.error(translations[langMode].noFieldsAvailable);
    } else {
      try {
        if (assignOpen) {
          setIsCreateAssignLoading(true)
        } else {
          setIsCreateLoading(true)
        }
        const response = await saveTask(
          activityId,
          taskData,
          accountNo,
          selectedfieldAgent,
          allowUpdateIfExists
        );
        if (assignOpen) {
          setIsCreateAssignLoading(false)
        } else {
          setIsCreateLoading(false)
        }
        if (response.header.code === 600) {
          toast.success("Task Created Successfully");
          setTaskData({});
          setInputFields([]);
          setAccountNo("");
          handleGoBack();
        } else {
          toast.error(response.body.value);
        }
      } catch (error) {
         if (assignOpen) {
          setIsCreateAssignLoading(false)
        } else {
          setIsCreateLoading(false)
        }
        console.error("Error in handleSaveTask:", error);
      }
    }
  };

  useEffect(() => {
    const storedOption = localStorage.getItem("selectedActivity");
    if (storedOption) {
      setSelectedOption(storedOption);
      setWorkflowId(storedOption);
    }
  }, [])

  return (
    <div className="w-full">
      <div className="flex gap-3 mt-2">
        <div
          onClick={handleGoBack}
          className={`p-2 rounded-full border cursor-pointer w-8 
            ${
              theme === "dark"
                ? "bg-gray-800 border-gray-600 hover:bg-gray-700"
                : ""
            }
            ${
              theme === "high-contrast"
                ? "high-contrast border border-gray-600"
                : ""
            }
            ${
              theme !== "dark" && theme !== "high-contrast"
                ? "border-gray-400 hover:bg-gray-200"
                : ""
            }`}
        >
          <FaArrowLeft
            className={`h-3 w-3 ${
              theme === "dark"
                ? "text-white"
                : theme === "high-contrast"
                ? "text-black"
                : "text-gray-700"
            }`}
          />
        </div>
        <h4
          className={` mt-1 uppercase text-sm font-semibold text-gray-800 ${
            theme === "dark"
              ? "dark-mode"
              : theme === "high-contrast"
              ? "high-contrast"
              : ""
          }`}
        >
          {translations[langMode].createnewtask}
        </h4>
      </div>

      <div
        className={`px-5 py-2 mt-2 bg-white  ${
          theme === "dark"
            ? "dark-mode"
            : theme === "high-contrast"
            ? "high-contrast"
            : ""
        }`}
      >
        {!activityId &&
        inputFields.mandatory.length === 0 &&
        inputFields.nonMandatory.length === 0 ? (
          <p className="text-red-500 font-semibold mt-10 text-center">
            {translations[langMode].selectMsg}
          </p>
        ) : inputFields.mandatory.length === 0 &&
          inputFields.nonMandatory.length === 0 ? (
          <p className="text-red-500 font-semibold mt-10 text-center">
            This activity does not have fields.
          </p>
        ) : (
          <div className="">
            <div>
              <div className="pt-5 flex justify-end items-center">
                {/* <button
                  type="button"
                  // onClick={handleSaveTask}
                  onClick={() => setBulkUploadOpen(true)}
                  className="px-3 py-2 text-white bg-yellow-400 hover:bg-yellow-500 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                >
                  Bulk Upload
                </button> */}

                {/* <button
                  type="button"
                  onClick={handleSaveTask}
                  className="px-3 py-2 text-white bg-blue-800 hover:bg-blue-900 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                >
                  {translations[langMode].create}
                </button> */}
                {/* <button
                  type="button"
                  // onClick={handleSaveTask}
                  onClick={() => setAssignOpen(true)}
                  className="px-3 py-2 text-white bg-green-500 hover:bg-green-600 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                >
                  Create and Assign
                </button> */}
              </div>
            </div>
                <h3 className={`text-md ${langMode === 'ar' ? 'text-sm ':'text-sm' } font-bold`}>Exit Account</h3>
                <div className="mt-2 ms-1">
                  <div>
                    <input
                      type="radio"
                      name="Should_be_Updated_Exit_Account"
                      value="true"
                      checked={allowUpdateIfExists === true}
                      onChange={() => setAllowUpdateIfExists(true)}
                    />
                    <label className="ml-2 text-sm font-medium text-gray-700">{translations[langMode].updateAlreadyExistingAccountEntries}</label>
                  </div>
                  <div className="mt-1">
                    <input
                      type="radio"
                      name="Create_new_Account"
                      value="false"
                      checked={allowUpdateIfExists === false}
                      onChange={() => setAllowUpdateIfExists(false)}
                    />
                    <label className="ml-2 text-sm font-medium text-gray-700">
                      {translations[langMode].createNewAccountEntries}
                    </label>
                  </div>
                </div>
            <h3 className={`text-md ${langMode === 'ar' ? 'text-sm ':'text-sm' } font-bold mt-5`}>Mandatory Fields</h3>
            <div className="grid grid-cols-1 gap-x-4 gap-y-4 lg:grid-cols-8 sm:grid-cols-4 py-2">
              {inputFields.mandatory.map((field, index) => (
                <>
                  <div className="sm:col-span-2" key={`mandatory_${index}`}>
                    <div className="relative">
                      <label
                        htmlFor={`input_${field.taskDetailsMetadataId}`}
                        className="block text-sm font-medium text-gray-700"
                      >
                        {field.fieldName}
                      </label>
                      <input
                        id={`input_${field.taskDetailsMetadataId}`}
                        type={
                          field.fieldType === "LONG" ||
                          field.fieldType === "DOUBLE"
                            ? "number"
                            : "text"
                        }
                        className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                        value={taskData[field.fieldName] || ""}
                        onChange={(e) =>
                          handleInputChange(field.fieldName, e.target.value)
                        }
                        onKeyUp={(e) => e.key === 'Enter' && handleAddAccount(field.fieldName, e.target.value)}
                        required
                      />
                      {errors[field.fieldName] && (
                        <p className="text-red-500 text-sm">
                          {errors[field.fieldName]}
                        </p>
                      )}
                    </div>
                  </div>
                </>
              ))}
              {/* <div className="relative" >
                <label className="block text-sm font-medium text-gray-700">Remarks</label>
                <textarea required value={remark} onChange={(e)=>setRemark(e.target.value)} className="rounded-md w-full" placeholder="Add Remarks" />
              </div> */}
            </div>
            <h3 className={`${langMode === 'ar' ? 'text-sm ':'text-sm' }  font-bold mt-5`} >Non-Mandatory Fields</h3>
            <div className="grid grid-cols-1 gap-x-4 gap-y-4 lg:grid-cols-8 sm:grid-cols-4 py-2">
              {inputFields.nonMandatory.map((field, index) => (
                <div className="sm:col-span-2" key={`nonMandatory_${index}`}>
                  <div className="relative">
                    <label
                      htmlFor={`input_${field.taskDetailsMetadataId}`}
                      className="block text-sm font-medium text-gray-700"
                    >
                      {field.fieldName}
                    </label>
                    <input
                      id={`input_${field.taskDetailsMetadataId}`}
                      type={field.fieldType === "DOUBLE" ? "number" : "text"}
                      className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                      value={taskData[field.fieldName] || ""}
                      onChange={(e) =>
                        handleInputChange(field.fieldName, e.target.value)
                      }
                      onKeyUp={(e) =>  e.key === 'Enter' && handleAddAccount(field.fieldName, e.target.value)}
                    />
                  </div>
                </div>
              ))}
            </div>

            <div>
              <div className="pt-5 flex sm:flex-nowrap flex-wrap justify-end items-center gap-3">
                {/* <button
                  type="button"
                  onClick={handleGoBack}
                  className="px-3 py-2 me-2 mb-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                >
                  {translations[langMode].cancel}
                </button> */}

                <CommonButton onClick={handleGoBack} variant="danger">
                  {translations[langMode].cancel}
                </CommonButton>

                {/* <button
                  type="button"
                  // onClick={handleSaveTask}
                  onClick={() => setBulkUploadOpen(true)}
                  className="px-3 py-2 text-white bg-yellow-400 hover:bg-yellow-500 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                >
                  Bulk Upload
                </button> */}

                <CommonButton
                  onClick={() => setBulkUploadOpen(true)}
                  variant="success"
                  className="whitespace-nowrap"
                >
                  Bulk Upload
                </CommonButton>

                {/* <button
                  type="button"
                  onClick={handleSaveTask}
                  className="px-3 py-2 text-white bg-blue-800 hover:bg-blue-900 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                >
                  {translations[langMode].create}
                </button> */}

                <CommonButton onClick={handleSaveTask} variant="primary" className={`${isCreateLoading ? "bg-opacity-60" : "bg-opacity-100"}`}>
                  {isCreateLoading ?  "Processing...":translations[langMode].create}
                </CommonButton>

                {/* <button
                  type="button"
                  onClick={() => setAssignOpen(true)}
                  className="px-3 py-2 text-white bg-green-500 hover:bg-green-600 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                >
                  Create and Assign
                </button> */}

                <CommonButton
                  onClick={() => setAssignOpen(true)}
                  variant="success"
                   className="whitespace-nowrap"
                >
                  Create and Assign
                </CommonButton>
              </div>
            </div>
          </div>
        )}
      </div>
      {assignOpen && (
        <FieldAgentModal
          assignOpen={assignOpen}
          setAssignOpen={setAssignOpen}
          handleSaveTask={handleSaveTask}
          selectedfieldAgent={selectedfieldAgent}
          setselectedfieldAgent={setselectedfieldAgent}
          isCreateLoading={isCreateAssignLoading}
        />
      )}
      {bulkUploadOpen && (
        <BulkUploadModal
          bulkUploadOpen={bulkUploadOpen}
          setBulkUploadOpen={setBulkUploadOpen}
          allowUpdateIfExists={allowUpdateIfExists}
        />
      )}
    </div>
  );
};

export default CreateTask;
